import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { setItem } from 'utils/localStorage';
import { history } from 'utils/history';
import { Main } from './components/Loadable';
import './style.css';

const LoginCallback = memo(() => {
  useEffect(() => {
    getToken();
  }, []);

  const getToken = () => {
    // console.log('LoginCallback');
    let hash = window.location.hash;
    let loginCallbackPrefix = '/loginCallback';
    hash.startsWith(loginCallbackPrefix) &&
      (hash = hash.substr(
        hash.indexOf(loginCallbackPrefix) + loginCallbackPrefix.length,
      ));

    const tokenData = {};

    hash
      .substr(1)
      .split('&')
      .forEach(item => {
        const elements = item.split('=');
        // console.log(elements);
        tokenData[decodeURI(elements[0])] = decodeURI(elements[1]);
      });

    if (tokenData) {
      // do something
      console.log('tokenData:', tokenData);
      console.log('tokenData login adfs:', tokenData.login_adfs);
      setItem('SMART_OFFICE_TOKEN', tokenData?.id_token);
      setItem('refresh_token', tokenData?.refresh_token);
      setItem('access_token', tokenData?.access_token);
      setItem('expires_in', tokenData?.expires_in);
      setItem('state', tokenData?.state);
      setItem('token_type', tokenData?.token_type);
      setItem('createTokenTime', Date.now());
      if (
        tokenData.login_adfs &&
        tokenData.login_adfs.toLowerCase() === 'true'
      ) {
        setItem('login_adfs', 'true');
      } else {
        setItem('login_adfs', 'false');
      }
      setItem('sessionId', tokenData?.sessionId);
      // history.push('/dashboard');
    }
    redirectToSSOPage();
  };

  const redirectToSSOPage = async () => {
    let response_type = encodeURIComponent('id_token token');
    let scope = encodeURIComponent('openid');
    let nonce = encodeURIComponent('anything');

    let state = encodeURIComponent('anything');
    let client_id = encodeURIComponent(
      `${process.env.REACT_APP_SSO_CLIENT_ID}`,
    );
    let redirect_uri = encodeURIComponent(
      `${process.env.REACT_APP_SSO_LOGIN_CALLBACK}`,
    );
    var tenantCode = 'thanhuy.vn';
    window.location.href = `${process.env.REACT_APP_SSO_URL_LOGIN}?response_type=${response_type}&scope=${scope}&nonce=${nonce}&state=${state}&client_id=${client_id}&redirect_uri=${redirect_uri}&tenant_code=${tenantCode}`;
  };

  return (
    <div className="login-callback">
      <Main />
    </div>
  );
});

LoginCallback.propTypes = {
  setToken: PropTypes.func.isRequired,
};
LoginCallback.defaultProps = {
  setToken: null,
};

export default LoginCallback;
